'use strict';
angular
    .module('trsModalDialog', ['ngSanitize', 'modalDialogHeightFixModule', 'btOpacityModule'])
    .factory('modalDialog', [
        '$modal',
        '$compile',
        '$timeout',
        'localStorageService',
        // '$injector',
        function ($modal, $compile, $timeout, localStorageService) {
            // let publicToolService = $injector.get('publicToolService');
            return {
                // type :  success:成功   error:失败  info:提示   warning:警告 ask:询问  collection：收藏（五角星）
                alertType: function (title, content, type, isButtonShow, confirm, cancel, time, btn1, btn2) {
                    var modalInstance = $modal.open({
                        templateUrl: './components/service/modalDialog/view/alertType_tpl.html',
                        windowClass: 'alertType',
                        backdrop: false,
                        keyboard: false,
                        controller: 'alertTypeCtrl',
                        resolve: {
                            params: function () {
                                return {
                                    title: title,
                                    content: content,
                                    type: type,
                                    isButtonShow: isButtonShow,
                                    time: time,
                                    btn1: btn1,
                                    btn2: btn2,
                                };
                            },
                        },
                    });
                    modalInstance.result.then(
                        function (result) {
                            if (angular.isFunction(confirm)) {confirm();}
                        },
                        function () {
                            if (angular.isFunction(cancel)) {cancel();}
                        }
                    );
                },
                // input模块
                inputModel: function (title, placeholder, confirm, content, cancel, isTextareaShow) {
                    return $modal.open({
                        templateUrl: './components/service/modalDialog/view/review_tpl.html',
                        windowClass: 'inputModel',
                        backdrop: false,
                        controller: 'reviewCtrl',
                        animation: false,
                        resolve: {
                            title: function () {
                                return title;
                            },
                            placeholder: function () {
                                return placeholder;
                            },
                            callback: function () {
                                return confirm;
                            },
                            content: function () {
                                return content;
                            },
                            cancel: function () {
                                return cancel;
                            },
                            isTextareaShow: function () {
                                return isTextareaShow;
                            },
                        },
                    });
                }, // 提示框模块
                confirmModal: function (title, content, confirm, cancel) {
                    return $modal.open({
                        templateUrl: './components/service/modalDialog/view/confirmModal_tpl.html',
                        windowClass: 'confirmModal',
                        backdrop: false,
                        controller: 'confirmModalCtrl',
                        resolve: {
                            title: function () {
                                return title;
                            },
                            content: function () {
                                return content;
                            },
                            callback: function () {
                                return confirm;
                            },
                            cancel: function () {
                                return cancel;
                            },
                        },
                    });
                },
                selectIndex: function (title, content, recordNum, confirm, forbArray) {
                    return $modal.open({
                        templateUrl: './components/service/modalDialog/view/selectIndex_tpl.html',
                        windowClass: 'selectIndex',
                        backdrop: false,
                        controller: 'selectIndexCtrl',
                        resolve: {
                            title: function () {
                                return title;
                            },
                            content: function () {
                                return content;
                            },
                            recordNum: function () {
                                return recordNum;
                            },
                            callback: function () {
                                return confirm;
                            },
                            forbArray: function () {
                                return forbArray;
                            },
                        },
                    });
                },
                // 保存模板提示
                // type :  success:成功   error:失败  info:提示   warning:警告
                saveModel: function (title, content, type, confirm) {
                    this.alertType(title, content, type, confirm);
                },
                // 带一条输入框的模块
                typingModel: function (title, content, callback) {
                    return $modal.open({
                        templateUrl: './components/service/modalDialog/view/typing_tpl.html',
                        windowClass: 'toBeCompiled-typing-window',
                        backdrop: false,
                        controller: 'typingCtrl',
                        resolve: {
                            transmission: function () {
                                return {
                                    title: title,
                                    content: content,
                                    callback: callback,
                                };
                            },
                        },
                    });
                },
                // 取稿
                takeDraft: function (items) {
                    var modalInstance = $modal.open({
                        templateUrl: './resourceCenter/service/modal/takeDraftModal/takeDraftModal.html',
                        windowClass: 'resource-take-draft',
                        backdrop: false,
                        resolve: {
                            items: function () {
                                return items;
                            },
                        },
                        controller: 'takeDraftCtrl',
                    });
                    return modalInstance;
                },

                /**
                 * [multiReportsAlert description] 多条返回信息提示框
                 * @param   {[type]}  data            [data description]
                 * @param   {[type]}  callback        [callback description]
                 * @param   {[type]}  cancelCallback  [cancelCallback description]
                 * @param   {[type]}  confirm         [confirm description]
                 * @param   {[type]}  cancel          [cancel description]
                 * @return  {[type]}                  [return description]
                 */
                multiReportsAlert: function (data, callback, cancelCallback, confirm, cancel) {
                    var modalInstance = $modal.open({
                        templateUrl: './components/service/modalDialog/view/multiReportsAlert_tpl.html',
                        windowClass: 'multi-reports-alert-window',
                        controller: 'multiReportsAlertCtrl',
                        backdrop: false,
                        keyboard: false,
                        // animation:false,
                        resolve: {
                            data: function () {
                                return data;
                            },
                            options: function () {
                                return {
                                    confirm: confirm,
                                    cancel: cancel
                                };
                            }
                        },
                    });
                    modalInstance.result.then(function () {
                        if (angular.isFunction(callback)) {
                            callback();
                        }
                    }, function () {
                        if (angular.isFunction(cancelCallback)) {
                            cancelCallback();
                        }
                    });
                },

                /**
                 * [multiSaveInfo description]多条保存信息
                 * @param  {[arr]} items [description]各渠道保存信息集合
                 * @return {[type]}      [description]
                 */
                multiSaveInfo: function (items) {
                    var modalInstance = $modal.open({
                        templateUrl: './components/service/modalDialog/view/multiSaveInfo_tpl.html',
                        windowClass: 'multi-reports-alert-window',
                        controller: 'multiSaveInfoCtrl',
                        backdrop: false,
                        keyboard: false,
                        // animation:false,
                        resolve: {
                            items: function () {
                                return items;
                            },
                        },
                    });
                    return modalInstance;
                },

                /**
                 * [isNeed description] 确认是否是涉密信息的提示框
                 * @param   {[type]}  isNeed          [isNeed description] 编辑稿件时不需要弹出该校验框
                 * @param   {[type]}  confirm         [confirm description]
                 * @param   {[type]}  cancel          [cancel description]
                 * @param   {[type]}  isFusionEditor  [isFusionEditor description]
                 * @return  {[type]}                  [return description]
                 */
                isSecretInformation: function (isNeed, confirm, cancel, isFusionEditor) {
                    let config = localStorageService.get('editCenter.configuration')['draftSecret'];
                    if (config && config.value.shield) {confirm(); return;}
                    if (true) {
                        confirm();
                        return;
                    }
                    this.alertType(
                        '请确认是否包含涉密信息',
                        '',
                        'warning',
                        true,
                        function () {
                            confirm();
                        },
                        function () {
                            cancel();
                        },
                        '',
                        '是',
                        '否'
                    );
                },

                /**
                 * [miniMize description] 最小化
                 * @param {object} [$scope] [description] 节点
                 * @param {[dom]} [$element] [description] 弹窗dom
                 * @return {[type]} [description]
                 */
                miniMize: function ($scope, $element) {
                    $element.addClass('modal-mini-mize');

                    /**
                     * [maxiMizing description] 窗口最大化
                     * @return {[type]} [description]
                     */
                    $scope.maxiMizing = function () {
                        $element.find('.mini-size').remove();
                        $element.removeClass('modal-mini-mize');
                        $element.css('left', 0);
                        reRender();
                    };

                    /**
                     * [reRender description] 重新计算排列
                     * @return {[type]} [description]
                     */
                    function reRender() {
                        $timeout(function () {
                            var modals = $('body').find('.modal-mini-mize');
                            var left = 0;
                            modals.each(function (index) {
                                $(this).css('left', left + 'px');
                                left =
                                    Number(
                                        $(this)
                                            .css('left')
                                            .replace(/px/, '')
                                    ) +
                                    $(this).width() +
                                    2;
                            });
                        }, 50);
                    }

                    /**
                     * [close description] 关闭标签
                     * @return {[type]} [description]
                     */
                    $scope.close = function () {
                        $scope.$close($scope.data.result);
                        reRender();
                    };
                    var dom = [
                        "<div class='mini-size'>",
                        "<span class='min-title'>" + $element.find('.publicModal .header p').html() + '</span>',
                        "<span ng-click='maxiMizing()' class='to-max'></span>",
                        "<span ng-click='close()' class='close-min'></span>",
                        '</div>',
                    ].join('');
                    dom = $compile($(dom))($scope);
                    var left;
                    reRender();
                    // var modals = $("body").find(".modal-mini-mize");

                    // if (modals.length === 1) {
                    //     left = 0;
                    // } else {
                    //     var lastModal = modals.eq(modals.length - 2);
                    //     left = lastModal.offset().left + lastModal.width();
                    // }
                    $element.append(dom);
                    $element.css({
                        left: left,
                    });
                },
                // type :  success:成功   error:失败  info:提示   warning:警告 ask:询问  collection：收藏（五角星）
                alertTypeWithCloseBtn: function (title, content, type, isButtonShow, confirm, cancel, time, btn1, btn2) {
                    var modalInstance = $modal.open({
                        templateUrl: './components/service/modalDialog/view/alertTypeWithCloceBtn_tpl.html',
                        windowClass: 'alertType',
                        backdrop: false,
                        keyboard: false,
                        controller: 'alertTypeWithCloseBtnCtrl',
                        resolve: {
                            params: function () {
                                return {
                                    title: title,
                                    content: content,
                                    type: type,
                                    isButtonShow: isButtonShow,
                                    time: time,
                                    btn1: btn1,
                                    btn2: btn2,
                                };
                            },
                        },
                    });
                    modalInstance.result.then(
                        function (result) {
                            if (!result || !result.close) {
                                if (angular.isFunction(confirm)) {confirm();}
                            }
                        },
                        function () {
                            if (angular.isFunction(cancel)) {cancel();}
                        }
                    );
                },
                requestErrorDialog: function (params) {
                    var modalInstance = $modal.open({
                        templateUrl: './components/service/modalDialog/view/requestErrorDialog.html',
                        windowClass: 'request-error-dialog',
                        backdrop: false,
                        keyboard: false,
                        controller: 'requestErrorDialogCtrl',
                        resolve: {
                            params: function () {
                                return params;
                            },
                        },
                    });
                    modalInstance.result.then(function (result) {

                    }, function () {

                    });
                }
            };
        },
    ])
    .controller('reviewCtrl', [
        '$scope',
        'title',
        'placeholder',
        'callback',
        '$validation',
        '$timeout',
        'content',
        'cancel',
        'isTextareaShow',
        function ($scope, title, placeholder, callback, $validation, $timeout, content, cancel, isTextareaShow) {
            if (angular.isDefined(content)) {
                $scope.content = content;
            }
            if (angular.isDefined(isTextareaShow)) {
                $scope.isTextareaShow = isTextareaShow;
            }
            $scope.cancel = function () {
                if (angular.isDefined(cancel)) {cancel();}
                $scope.$close();
            };
            $timeout(function () {
                $scope.confirm = function () {
                    $validation.validate($scope.infoForm).success(function () {
                        callback($scope.infoForm.content.$viewValue);
                        $scope.$close();
                    });
                };
            });
            $scope.title = title;
            $scope.placeholder = placeholder;
        },
    ])
    .controller('confirmModalCtrl', [
        '$scope',
        '$sce',
        'title',
        'content',
        'callback',
        'cancel',
        function ($scope, $sce, title, content, callback, cancel) {
            $scope.cancel = function () {
                if (angular.isDefined(cancel)) {cancel();}
                $scope.$close();
            };
            $scope.isConfirm = function () {
                callback();
                $scope.$close();
            };
            $scope.title = title;
            $scope.content = content;
        },
    ])
    .controller('selectIndexCtrl', [
        '$scope',
        'title',
        'content',
        'recordNum',
        'callback',
        'forbArray',
        function ($scope, title, content, recordNum, callback, forbArray) {
            $scope.dropLists = [];
            $scope.selectedPosition = '-1';
            if (angular.isArray(forbArray)) {
                $scope.forbArray = forbArray;
            }
            for (var i = 0; i < recordNum; i++) {
                var temp = i + 1;
                if ($scope.selectedPosition === '-1') {$scope.selectedPosition = $scope.forbArray.indexOf(temp) > -1 ? $scope.selectedPosition : temp + '';}
                $scope.dropLists.push(temp);
            }
            $scope.cancel = function () {
                $scope.$close();
            };
            $scope.isConfirm = function () {
                callback($scope.selectedPosition);
                $scope.$close();
            };
            $scope.title = title;
            $scope.content = content;
        },
    ])
    .controller('typingCtrl', [
        '$scope',
        '$modalInstance',
        '$validation',
        'transmission',
        function ($scope, $modalInstance, $validation, transmission) {
            initData();
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };
            $scope.confirm = function () {
                $validation.validate($scope.typingForm).success(function () {
                    transmission.callback($scope.content);
                    $modalInstance.dismiss();
                });
            };

            /**
             * [initData 初始化数据]
             *
             * @return  {[type]}  [return description]
             */
            function initData() {
                $scope.title = transmission.title;
                $scope.content = transmission.content;
            }
        },
    ])
    .controller('takeDraftCtrl', [
        '$scope',
        '$state',
        '$modalInstance',
        'trsHttpService',
        'items',
        '$filter',
        function ($scope, $state, $modalInstance, trsHttpService, items, $filter) {
            var selectChanel = {},
                itemLength = items.length;
            $scope.selectChanel = selectChanel;
            // 初始化数据
            initStatus();
            initData();

            // 切换tab选型卡
            $scope.setCurrMedia = function (media) {
                $scope.currMedia = media;
            };

            // 关闭窗口
            $scope.close = function () {
                $modalInstance.dismiss();
            };
            // i 我
            $scope.changeRadioStatus = function () {
                selectChanel.ToMy.isShow = !selectChanel.ToMy.isShow;
                selectChanel.ToMy.label = $scope.mediasArray[0].mediaName;
                setDirectEditDisabled();
            };
            // 网站
            $scope.changeSingleRadio = function (node) {
                selectChanel.Web = {
                    label: $scope.mediasArray[2].mediaName + '>' + $scope.selectCollect.websiteSiteItem.SITENAME + '>' + node.CHNLNAME,
                    isShow: true,
                    item: node,
                };
                setDirectEditDisabled();
            };
            // 纸媒
            $scope.selectPaperItem = function (item) {
                selectChanel.Paper = {
                    label:
                        $scope.mediasArray[1].mediaName +
                        '>' +
                        $scope.NewspaperData[$scope.selectCollect.selectNewspaper].SITENAME +
                        '>' +
                        $scope.NewspaperDieCiData[$scope.selectCollect.selectDieCi].CHNLNAME +
                        '>' +
                        item.CHNLNAME,
                    isShow: true,
                    item: item,
                };
                setDirectEditDisabled();
            };

            /**
             * [initData 初始化数据]
             *
             * @return  {[type]}  [return description]
             */
            function initData() {
                requestWebsiteSite();
                requestNewspaper();
            }

            /**
             * [initStatus 初始化状态]
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                // 当前选项卡
                $scope.currMedia = 1;
                // 标题列表是否出现
                $scope.isTitleMoreShow = false;
                // 直接编辑
                $scope.directDisabled = true;
                // 初始化纸媒时间
                $scope.PaperPubDate = new Date();

                $scope.mediasArray = [
                    {
                        mediaName: '我的',
                        mediaType: 1,
                    },
                    {
                        mediaName: '纸媒',
                        mediaType: 2,
                    },
                    {
                        mediaName: '网站',
                        mediaType: 3,
                    },
                    {
                        mediaName: 'APP',
                        mediaType: 4,
                    },
                ];
                $scope.websiteSiteParams = {
                    serviceid: 'mlf_websiteconfig',
                    methodname: 'queryWebSites',
                };
                $scope.webExpandedTest = [];
                $scope.NewspaperParams = {
                    serviceid: 'mlf_paperset',
                    methodname: 'queryPagers',
                };
                $scope.selectCollect = {
                    websiteSite: '',
                    selectNewspaper: 0,
                    selectDieCi: 0,
                };
                var channel = '',
                    depart = '',
                    totalWords = 0,
                    docIds = '';
                angular.forEach(items, function (n, i) {
                    channel += ',' + n.DOCCHANNEL;
                    depart += ',' + n.ZB_SOURCE_SITE;
                    docIds += ',' + n.ZB_GUID;
                    totalWords += Number(n.TXS);
                    n.DOCTITLE = n.DOCTITLE || n.TITLE; // 共享稿库和其他几个列表返回字段不同
                });
                $scope.selectDocsInfo = {
                    channel: channel.substr(1),
                    depart: depart.substr(1),
                    size: items.length,
                    totalWords: totalWords,
                    items: items,
                };
                // ChnlDocIds = docIds.substr(1);

                selectChanel.Paper = {};
                selectChanel.Web = {};
                selectChanel.APP = {};
                selectChanel.ToMy = {
                    isShow: false,
                };
            }

            $scope.sendTimeSigned = function () {
                var timeSigned = $filter('date')($scope.PaperPubDate, 'yyyy-MM-dd').toString();
                $modalInstance.close(timeSigned);
            };

            // 树配置开始
            $scope.treeOptions = {
                nodeChildren: 'CHILDREN',
                dirSelectable: true,
                allowDeselect: false,
                injectClasses: {
                    ul: 'a1',
                    li: 'a2',
                    liSelected: 'a7',
                    iExpanded: 'a3',
                    iCollapsed: 'a4',
                    iLeaf: 'a5',
                    label: 'a6',
                    labelSelected: 'take-draft-tree-label-sel',
                },
                isLeaf: function (node) {
                    return node.CHILDREN === undefined;
                },
            };
            // 折叠时触发函数
            $scope.showToggle = function (node) { };
            // 选中时触发函数
            $scope.showSelected = function (node) { };

            /**
             * [requestWebsiteSite 请求网站站点列表]
             *
             * @param   {[type]}  callback  [callback description]
             *
             * @return  {[type]}            [return description]
             */
            function requestWebsiteSite(callback) {
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.websiteSiteParams, 'post').then(function (data) {
                    if (angular.isFunction(callback)) {
                        callback(data);
                    } else {
                        $scope.websiteSiteData = data.DATA;
                        $scope.selectCollect.websiteSite = $scope.websiteSiteData[0].SITEID;
                        $scope.selectCollect.websiteSiteItem = $scope.websiteSiteData[0];
                        requestWebTree($scope.selectCollect.websiteSite);
                    }
                });
            }

            /**
             * [requestWebsiteTree 请求网站的树]
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.requestWebsiteTree = function (item) {
                if ($scope.selectCollect.websiteSite != item.SITEID) {
                    $scope.selectCollect.websiteSite = item.SITEID;
                    $scope.selectCollect.websiteSiteItem = item;
                    requestWebTree(item.siteId);
                }
            };

            /**
             * [requestWebTree 请求网站导航树]
             *
             * @param   {[type]}  siteId    [siteId description]
             * @param   {[type]}  callback  [callback description]
             *
             * @return  {[type]}            [return description]
             */
            function requestWebTree(siteId, callback) {
                var params = {
                    serviceid: 'mlf_websiteconfig',
                    methodname: 'queryClassifyBySite',
                    SiteId: siteId,
                    platform: 1, // 取稿默认到待编，传1
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    if (angular.isFunction(callback)) {
                        callback(data);
                    } else {
                        $scope.websiteTreeData = [data];
                        ExpandedNodes($scope.webExpandedTest, $scope.websiteTreeData);
                    }
                });
            }

            /**
             * [ExpandedNodes 展开树节点]
             *
             * @param   {[type]}  expandedTest    [expandedTest description]
             * @param   {[type]}  dataForTheTree  [dataForTheTree description]
             *
             * @return  {[type]}                  [return description]
             */
            function ExpandedNodes(expandedTest, dataForTheTree) {
                expandedTest = [];
                expandedTest.push(dataForTheTree[0]);
            }

            /**
             * [requestNewspaper 请求报纸列表]
             *
             * @param   {[type]}  callback  [callback description]
             *
             * @return  {[type]}            [return description]
             */
            function requestNewspaper(callback) {
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.NewspaperParams, 'post').then(function (data) {
                    if (angular.isFunction(callback)) {
                        callback(data);
                    } else {
                        $scope.NewspaperData = data.DATA;
                        requestNewspaperDieCi($scope.NewspaperData[0].SITEID);
                    }
                });
            }

            /**
             * [requestNewspaperDieCi 请求叠次报纸]
             *
             * @param   {[type]}  siteId  [siteId description]
             * @param   {[type]}  index   [index description]
             *
             * @return  {[type]}          [return description]
             */
            $scope.requestNewspaperDieCi = function (siteId, index) {
                if ($scope.selectCollect.selectNewspaper != index) {
                    $scope.selectCollect.selectNewspaper = index;
                    $scope.selectCollect.selectDieCi = 0;
                    requestNewspaperDieCi(siteId);
                }
            };

            /**
             * [requestNewspaperDieCi 请求采编的报纸叠次数据]
             *
             * @param   {[type]}  siteId    [siteId description]
             * @param   {[type]}  callback  [callback description]
             *
             * @return  {[type]}            [return description]
             */
            function requestNewspaperDieCi(siteId, callback) {
                var params = {
                    serviceid: 'mlf_paperset',
                    methodname: 'queryDieCis',
                    PaperId: siteId,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    if (angular.isFunction(callback)) {
                        callback(data);
                    } else {
                        $scope.NewspaperDieCiData = data;
                        if (data && data[0]) {
                            requestNewspaperCaiBianFn(siteId, $scope.NewspaperDieCiData[0].CHANNELID);
                        }
                    }
                });
            }
            // 请求采编版面列表
            $scope.requestNewspaperCaiBian = function (siteId, channelId, index) {
                $scope.selectCollect.selectDieCi = index;
                requestNewspaperCaiBianFn(siteId, channelId);
            };

            /**
             * [requestNewspaperCaiBianFn 请求采编的报纸版面图数据]
             *
             * @param   {[type]}  siteId     [siteId description]
             * @param   {[type]}  channelId  [channelId description]
             *
             * @return  {[type]}             [return description]
             */
            function requestNewspaperCaiBianFn(siteId, channelId) {
                var params = {
                    serviceid: 'mlf_paper',
                    methodname: 'queryCaiBianBanMians',
                    PaperId: siteId,
                    DieCiId: channelId,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    if (data.length < 1) {
                        $scope.NewspaperCaiBianData = 0;
                    } else {
                        $scope.NewspaperCaiBianData = data;
                    }
                });
            }

            // 直接编辑
            $scope.directEdit = function () {
                if (!$scope.directDisabled) {
                    var sendObj = {};
                    for (var name in selectChanel) {
                        if (selectChanel[name].isShow) {
                            if (name == 'ToMy') {
                                sendObj[name] = true;
                            } else if (name == 'Paper') {
                                sendObj[name] = selectChanel[name].item.CHANNELID;
                                sendObj.PaperPubDate = $scope.PaperPubDate && $filter('date')($scope.PaperPubDate, 'yyyy-MM-dd').toString();
                            } else if (name == 'Web') {
                                sendObj[name] = selectChanel[name].item.CHANNELID;
                            }
                        }
                    }
                    sendObj.items = items;
                    sendObj.btnOp = 1;
                    $modalInstance.close(sendObj);
                }
            };

            // 稍后编辑
            $scope.sendInfo = function () {
                var sendObj = {};
                for (var name in selectChanel) {
                    if (selectChanel[name].isShow) {
                        if (name == 'ToMy') {
                            sendObj[name] = true;
                        } else if (name == 'Paper') {
                            sendObj[name] = selectChanel[name].item.CHANNELID;
                            sendObj.PaperPubDate = $scope.PaperPubDate && $filter('date')($scope.PaperPubDate, 'yyyy-MM-dd').toString();
                        } else if (name == 'Web') {
                            sendObj[name] = selectChanel[name].item.CHANNELID;
                        }
                    }
                }
                sendObj.items = items;
                sendObj.btnOp = 2;
                $modalInstance.close(sendObj);
            };
            // 移除选中的渠道
            $scope.removeChannel = function (item) {
                item.isShow = false;
                setDirectEditDisabled();
            };

            /**
             * [setDirectEditDisabled 单稿件单渠道可直接编辑]
             *
             * @return  {[type]}  [return description]
             */
            function setDirectEditDisabled() {
                var channelConut = 0;
                for (var name in selectChanel) {
                    if (selectChanel[name].isShow) {
                        channelConut++;
                    }
                }
                if ((itemLength == 1 && channelConut == 1) || selectChanel.APP.isShow === true) {
                    $scope.directDisabled = false;
                } else {
                    $scope.directDisabled = true;
                }
            }
        },
    ])
    .controller('multiReportsAlertCtrl', [
        '$scope',
        '$modalInstance',
        '$timeout',
        'data',
        'options',
        function ($scope, $modalInstance, $timeout, data, options) {
            $scope.status = {
                issuccess: data.ISSUCCESS,
                title: data.TITLE,
                ISNEWFORMAT: true, // 是否启用新模式提醒
                confirm: options.confirm,
                cancel: options.cancel
            };
            $scope.reports = {
                success: [],
                fail: [],
            };

            if (data.ISSUCCESS == 'false') {
                angular.forEach(data.REPORTS, function (value, key) {
                    if (value.ISSUCCESS == 'true') {
                        $scope.reports.success.push(value);
                    } else {
                        if (value.ISNEWFORMAT === '0') {
                            $scope.status.ISNEWFORMAT = false;
                        }
                        $scope.reports.fail.push(value);
                    }
                });
            } else {
                angular.forEach(data.REPORTS, function (value, key) {
                    $scope.reports.success.push(value);
                });
                $timeout(function () {
                    $modalInstance.close();
                }, 4000);
            }

            $scope.cancel = function () {
                if ($scope.status.cancel) {
                    $modalInstance.dismiss();
                } else {
                    $modalInstance.close();
                }
            };
            $scope.confirm = function () {
                $modalInstance.close();
            };
        },
    ])

    .controller('multiSaveInfoCtrl', [
        '$scope',
        '$modalInstance',
        'items',
        'messagePublishService',
        function ($scope, $modalInstance, items, messagePublishService) {
            initStatus();

            /**
             * [initStatus 初始化状态]
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.data = {
                    // 传入执行数据（第一条为总长度，后为判断长度）
                    items: items,
                    // 显示的title
                    title: '',
                    // 显示操作类型，比如：删除、保存、修改等等
                    type: '',
                };
            }
            messagePublishService.subscribe(
                'fusionSaveInfo',
                function (event, data) {
                    $scope.data.items.push(data.list);
                    $scope.data.title = data.title ? data.title : '保存进度';
                    $scope.data.type = data.type ? data.type : '保存';
                },
                $scope
            );
            $scope.cancel = function () {
                $modalInstance.close();
            };
            $scope.confirm = function () {
                $modalInstance.close();
            };
        },
    ])
    .controller('alertTypeWithCloseBtnCtrl', [
        '$scope',
        '$modalInstance',
        'params',
        function ($scope, $modalInstance, params) {
            initStatus();

            /**
             * [initStatus 初始化状态]
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.status = {
                    type: params.type,
                    title: params.title,
                    content: params.content,
                    isButtonShow: params.isButtonShow,
                    time: !!params.time ? params.time : 2000,
                    btn1: params.btn1 || '取消',
                    btn2: params.btn2 || '确定',
                };
                $scope.status.contentStyle =
                    $scope.status.isButtonShow === true || $scope.status.isButtonShow === 'cancel' || $scope.status.isButtonShow == 'confirm'
                        ? { 'margin-top': '85px' }
                        : {}; // 有按钮，和没按钮，margin-top是不同的
                if (!$scope.status.isButtonShow) {
                    setTimeout(function () {
                        $modalInstance.close();
                    }, $scope.status.time);
                }
            }
            $scope.confirm = function () {
                $modalInstance.close();
            };
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };
            $scope.close = function () {
                $modalInstance.close({
                    close: true
                });
            };
        },
    ]).controller('alertTypeCtrl', [
        '$scope',
        '$modalInstance',
        'params',
        function($scope, $modalInstance, params) {
            initStatus();

            /**
             * [initStatus 初始化状态]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.status = {
                    type: params.type,
                    title: params.title,
                    content: params.content,
                    isButtonShow: params.isButtonShow,
                    time: !!params.time ? params.time : 2000,
                    btn1: params.btn1 || '取消',
                    btn2: params.btn2 || '确定',
                };
                $scope.status.contentStyle =
                    $scope.status.isButtonShow === true || $scope.status.isButtonShow === 'cancel' || $scope.status.isButtonShow === 'confirm'
                        ? { 'margin-top': '85px' }
                        : {}; // 有按钮，和没按钮，margin-top是不同的
                if (!$scope.status.isButtonShow) {
                    setTimeout(function() {
                        $modalInstance.close();
                    }, $scope.status.time);
                }
            }
            $scope.confirm = function() {
                $modalInstance.close();
            };
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        },
    ])
    .controller('requestErrorDialogCtrl', [
        '$scope',
        '$modalInstance',
        'params',
        function ($scope, $modalInstance, params) {
            initStatus();

            /**
             * [initStatus description]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.data = {
                    code: params.status,
                    data: params.data
                };
            }
            $scope.confirm = function () {
                var input = document.getElementsByClassName('error-content-dialog')[0];
                input.select();
                document.execCommand('copy');
                $modalInstance.close();
            };
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };
        }
    ]);
